import React, { useEffect, useState } from "react";
import { withAppContextDecorators } from '@/common/AppContext';
import { Breadcrumb, Tabs } from 'antd';
import './index.less';
import LayoutContainer from "@/components/pc/LayoutContainer";
import NewsTrends from "./newsTrends";
import SocialResponsibility from "./socialResponsibility";
import PartyBuilding from "./partyBuilding";
import qs from 'qs'
import { useHistory } from "react-router-dom";

const GcInfo = (props) => {
    const { TabPane } = Tabs;
    const history = useHistory()
    const search = qs.parse(history.location.search, { ignoreQueryPrefix: true })
    const [selectTabs, setSelectTabs] = useState(search.key || '1');

    function callback(key) {
        document.getElementById('root').scrollTop = 0;
        setSelectTabs(key);
        history.push({pathname: '/gcInfo', search: `key=${key}`})
    }

    return <LayoutContainer>
        <div id="gcInfo">
            <div className={'banner'}>
                <img src={require('@/assets/images/gc-info/banner.jpg')}/>
            </div>

            <div id="tabList">
                <Tabs className={'tabList'} defaultActiveKey={selectTabs} onChange={callback}>
                    <TabPane tab="新闻动态" key="1"><NewsTrends/></TabPane>
                    <TabPane tab="社会责任" key="2"><SocialResponsibility/></TabPane>
                    <TabPane tab="党建工作" key="3"><PartyBuilding/></TabPane>
                </Tabs>
            </div>
        </div>
    </LayoutContainer>
}
export default withAppContextDecorators(GcInfo)
